import {Box, Typography} from '@mui/material';
import {get_price_str, text_shadow_css} from 'common';

export default function HorizontalBarGraph(props: {
	barcolor: string;
	start_value: number;
	end_value: number;
	current_value: number;
	direction: 'left' | 'right';
	line_mode?: boolean;
	bgcolor?: string;
}) {
	const {direction, barcolor, start_value, end_value, current_value, line_mode, bgcolor} = props;

	const adjusted_current = direction === 'right' ? Math.max(Math.min(current_value, end_value), start_value) : Math.min(Math.max(current_value, end_value), start_value);

	const percentage = Math.min(1.0, Math.max((current_value - start_value) / (end_value - start_value), 0.0));
	const cur_width = `${percentage * 100}%`;

	const cur_distance = adjusted_current - start_value;
	const cur_percentage = (cur_distance / start_value) * 100;

	return (
		<Box width="100%" height="100%" position="relative">
			<Box id="bg" width="100%" height="100%" position="absolute" bgcolor={bgcolor} />

			{percentage > 0 && (
				<Box
					id="value"
					width={cur_width}
					height="100%"
					position="absolute"
					bgcolor={line_mode ? 'transparent' : barcolor}
					right={direction === 'left' ? 0 : 'auto'}
					left={direction === 'right' ? 0 : 'auto'}
					borderLeft={direction === 'left' && cur_distance !== 0 && line_mode ? '2px solid green' : 'none'}
					borderRight={direction === 'right' && cur_distance !== 0 && line_mode ? '2px solid green' : 'none'}
					padding="0px 2px"
				/>
			)}

			{percentage > 0 && (
				<Box position="absolute" right={direction === 'right' ? 0 : 'auto'} left={direction === 'left' ? 0 : 'auto'}>
					{cur_distance !== 0 && (
						<Typography variant="caption" px={0.5}>
							{get_price_str(cur_percentage) + '%'}
						</Typography>
					)}
				</Box>
			)}
		</Box>
	);
}
